<div
  [class.chat-input-focused]="isInputFocused"
  class="chat-container pb-4 md:p-4 overflow-hidden"
>
  <div
    class="chat-window shadow-xl flex flex-col transition-all duration-500 ease-in-out rounded-4xl overflow-hidden"
    [ngClass]="{
      'chat-window-collapsed': !messages || messages.length === 0,
      'chat-window-expanded': messages && messages.length > 0,
    }"
    [class.chat-input-focused]="isInputFocused"
    style="
      background: #06090d;
      border: 1px solid rgba(231, 181, 63, 0.25);
      min-height: 200px;

      max-height: calc(100vh - 140px);
      width: 100%;
      display: flex;
      flex-direction: column;
    "
  >
    <!-- Loader -->
    <div *ngIf="loading" class="loader">
      <div class="spinner"></div>
      Loading messages...
    </div>

    <!-- Header -->
    <div
      class="px-4 py-3 sm:px-5 sm:py-3.5 flex items-center justify-between flex-shrink-0 chat-header"
      style="background: #080c10; border-bottom: 1px solid #1e293b"
    >
      <div class="flex items-center gap-3">
        <div
          class="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
          style="
            background: rgba(231, 181, 63, 0.08);
            border: 1px solid rgba(231, 181, 63, 0.2);
          "
        >
          <img
            src="https://cmax-banners.pages.dev/assets/hr-logo.png"
            alt="C_Max Logo"
            class="w-full h-full object-contain p-1"
          />
        </div>
        <div>
          <h4
            style="
              font-family: &quot;Barlow Condensed&quot;, sans-serif;
              font-size: 0.82rem;
              font-weight: 800;
              color: #e2e8f0;
              letter-spacing: 0.02em;
              margin: 0;
            "
          >
            Customer Support
          </h4>
          <p
            style="
              font-size: 0.58rem;
              font-weight: 700;
              color: #e7b53f;
              text-transform: uppercase;
              letter-spacing: 0.12em;
              display: flex;
              align-items: center;
              gap: 0.35rem;
              margin: 0;
            "
          >
            <span
              style="
                width: 5px;
                height: 5px;
                background: #e7b53f;
                border-radius: 50%;
                box-shadow: 0 0 5px #e7b53f;
                animation: chatPulse 2s ease-in-out infinite;
                display: inline-block;
              "
            ></span>
            Online
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <button
          (click)="showHideChat()"
          class="action-button minimize-button"
          style="
            padding: 0.4rem;
            color: #94a3b8;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 7px;
            transition: all 0.15s;
            display: flex;
            align-items: center;
          "
          onmouseover="
            this.style.color = '#f87171';
            this.style.background = 'rgba(248,113,113,.08)';
          "
          onmouseout="
            this.style.color = '#94a3b8';
            this.style.background = 'none';
          "
        >
          <fa-icon
            [icon]="Minimize"
            style="
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          ></fa-icon>
        </button>

        <button
          (click)="showHideChat()"
          class="action-button close-button"
          style="
            padding: 0.4rem;
            color: #94a3b8;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 7px;
            transition: all 0.15s;
            display: flex;
            align-items: center;
          "
          onmouseover="
            this.style.color = '#f87171';
            this.style.background = 'rgba(248,113,113,.08)';
          "
          onmouseout="
            this.style.color = '#94a3b8';
            this.style.background = 'none';
          "
        >
          <fa-icon
            [icon]="Close"
            style="
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          ></fa-icon>
        </button>
      </div>
    </div>

    <!-- Chat Messages Section -->
    <div
      #chatBody
      (scroll)="onScroll($event)"
      class="chat-messages flex flex-col p-4 sm:p-5 flex-grow overflow-y-auto space-y-3 chat-body"
      [ngClass]="{
        'overflow-y-auto': messages && messages.length > 0,
        'overflow-hidden': !messages || messages.length === 0,
        'chat-screen-input-focused': isInputFocused,
      }"
      style="
        background: #06090d;
        min-height: 200px;

        max-height: calc(100vh - 140px);

        overflow-y: auto;
        display: flex;
        flex-direction: column;
        width: 100%;
        scrollbar-width: thin;
        scrollbar-color: rgba(231, 181, 63, 0.2) transparent;
      "
    >
      <div
        *ngIf="!messages || messages.length === 0"
        class="flex flex-col items-center justify-center h-full text-center welcome-screen my-auto"
        style="padding: 2rem 0"
      >
        <h1
          style="
            font-family: &quot;Barlow Condensed&quot;, sans-serif;
            color: #e2e8f0;
            font-size: 1.6rem;
            font-weight: 800;
            letter-spacing: 0.02em;
            margin-bottom: 0.5rem;
          "
        >
          We are here for You
        </h1>
        <p
          style="
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
            color: #94a3b8;
            font-size: 0.8rem;
            max-w: 240px;
            margin: 0;
            line-height: 1.4;
          "
        >
          Welcome to support. This chat will be monitored to ensure safety.
        </p>
      </div>

      <div
        *ngFor="let message of messages"
        class="w-full flex my-1"
        [ngClass]="{
          'justify-end':
            message?.MessageFrom == 'Customer' ||
            message?.SenderId == getUserId(),
          'justify-start':
            message?.MessageFrom != 'Customer' ||
            message?.SenderId != getUserId(),
        }"
      >
        <div
          *ngIf="
            message?.MessageType != 'UnEngaged' &&
            (message?.MessageFrom == 'Customer' ||
              message?.SenderId == getUserId())
          "
          class="max-w-[75%] min-w-[32%] md:min-w-[38%] flex flex-col items-end gap-1"
        >
          <div
            class="customer-message-bubble text-white shadow-lg break-words max-w-full relative overflow-hidden"
            style="
              background: #080c10;
              border: 1px solid rgba(231, 181, 63, 0.25);
              border-radius: 14px 14px 2px 14px;
              padding: 0.6rem 0.75rem 1.1rem 0.75rem;
            "
          >
            <div
              *ngIf="message.ImageUrl"
              class="image-container relative mb-2 max-w-full mt-1"
            >
              <img
                [src]="message?.ImageUrl"
                alt="Selected Image"
                class="w-full max-w-sm h-auto rounded-lg cursor-pointer hover:opacity-85 transition-opacity"
                style="border: 1px solid rgba(231, 181, 63, 0.15)"
                (click)="openImageModal(message.ImageUrl)"
              />
            </div>

            <p
              style="
                line-height: 1.4;
                margin: 0;
                word-wrap: break-word;
                word-break: break-all;
                overflow-wrap: break-word;
                white-space: pre-wrap;
                font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
                font-size: 0.8rem;
                color: #e2e8f0;
              "
            >
              {{ message?.Message }}
            </p>

            <div class="w-max absolute right-[8px] bottom-[4px]">
              <span
                class="message-status w-full float-right justify-end flex-row-reverse"
              >
                <fa-icon
                  *ngIf="message.IsDelivered && message.IsSeen"
                  [icon]="CheckDouble"
                  style="font-size: 11px; color: #e7b53f"
                  title="Seen"
                ></fa-icon>

                <fa-icon
                  *ngIf="message.IsDelivered && !message.IsSeen"
                  [icon]="CheckDouble"
                  style="font-size: 11px; color: #64748b"
                  title="Delivered"
                ></fa-icon>

                <fa-icon
                  *ngIf="!message.IsDelivered"
                  [icon]="Check"
                  style="font-size: 11px; color: #64748b"
                  title="Sent"
                ></fa-icon>
              </span>
            </div>
          </div>

          <span
            class="customer-timestamp"
            style="
              font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
              font-size: 0.62rem;
              color: #64748b;
              padding-right: 2px;
            "
          >
            {{ message.Time | date: "hh:mm a" }}
          </span>
        </div>

        <div
          *ngIf="
            message?.MessageType != 'UnEngaged' &&
            message?.MessageFrom != 'Customer' &&
            message?.SenderId != getUserId()
          "
          class="max-w-[75%] min-w-[32%] md:min-w-[38%] flex flex-col items-start gap-1"
        >
          <div
            class="support-message-bubble shadow-lg break-words max-w-full overflow-hidden"
            style="
              background: rgba(231, 181, 63, 0.06);
              border: 1px solid rgba(231, 181, 63, 0.25);
              border-radius: 14px 14px 14px 2px;
              padding: 0.6rem 0.75rem;
            "
          >
            <div
              *ngIf="message.ImageUrl"
              class="image-container relative mb-2 max-w-full mt-1"
            >
              <img
                [src]="message?.ImageUrl"
                alt="Selected Image"
                class="w-full max-w-sm h-auto rounded-lg cursor-pointer hover:opacity-85 transition-opacity"
                style="border: 1px solid rgba(231, 181, 63, 0.15)"
                (click)="openImageModal(message.ImageUrl)"
              />
            </div>

            <p
              style="
                line-height: 1.4;
                margin: 0;
                white-space: pre-wrap;
                word-wrap: break-word;
                word-break: break-all;
                overflow-wrap: break-word;
                font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
                font-size: 0.8rem;
                color: #e2e8f0;
              "
            >
              {{ message?.Message }}
            </p>
          </div>

          <span
            class="support-timestamp"
            style="
              font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
              font-size: 0.62rem;
              color: #64748b;
              padding-left: 2px;
            "
          >
            {{ message.Time | date: "hh:mm a" }}
          </span>
        </div>

        <div
          *ngIf="message.MessageType == 'UnEngaged'"
          class="w-full flex justify-center my-2"
        >
          <div
            style="
              background: rgba(248, 113, 113, 0.06);
              border: 1px solid rgba(248, 113, 113, 0.15);
              border-radius: 8px;
              padding: 0.4rem 1rem;
              text-align: center;
            "
          >
            <p
              style="
                font-family: &quot;Barlow Condensed&quot;, sans-serif;
                font-size: 0.68rem;
                font-weight: 700;
                color: #f87171;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                margin: 0;
              "
            >
              Chat session has ended
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <ng-template #noChatFound>
      <div
        class="flex flex-col items-center h-[58dvh] justify-center text-white p-6 rounded-lg"
      >
        <div class="relative">
          <div
            class="absolute top-2 left-2 bg-teal-400 p-4 rounded-lg text-white"
          >
            <span class="flex space-x-1">
              <span class="w-2 h-2 bg-white rounded-full"></span>
              <span class="w-2 h-2 bg-white rounded-full"></span>
              <span class="w-2 h-2 bg-white rounded-full"></span>
            </span>
          </div>
          <div class="bg-teal-200 p-6 rounded-lg ml-6 mt-6"></div>
        </div>
        <h4 class="text-gray-300 mt-4">Start Conversation.</h4>
      </div>
    </ng-template> -->

    <!-- Display Selected in input Image -->
    <div
      *ngIf="imageURL"
      class="selected-image-preview -mb-2 w-48 ml-2 selected-image-shown relative"
    >
      <img
        [src]="imageURL"
        alt="Selected Image"
        class="w-full h-auto max-h-32 rounded-md border border-gray-400 object-contain"
      />
      <button
        (click)="clearSelection()"
        class="absolute top-1 right-1 bg-gray-800 text-white rounded-full p-1 hover:bg-red-500 transition-colors z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Display Selected Image End-->

    <!-- Input Area -->
    <div
      class="chat-input px-4 py-3 flex-shrink-0"
      style="background: #06090d; border-top: 1px solid #1e293b"
    >
      <div
        style="
          background: #080c10;
          border: 1px solid rgba(231, 181, 63, 0.3);
          border-radius: 10px;
          padding: 0.35rem;
          display: flex;
          align-items: center;
          gap: 0.4rem;
          width: 100%;
        "
      >
        <button
          (click)="fileInput.click()"
          class="plus-button flex items-center justify-center transition-all flex-shrink-0"
          style="
            width: 30px;
            height: 30px;
            background: rgba(231, 181, 63, 0.06);
            border: 1px solid rgba(231, 181, 63, 0.2);
            border-radius: 7px;
            color: #e7b53f;
            cursor: pointer;
          "
          onmouseover="this.style.background = 'rgba(231,181,63,.12)'"
          onmouseout="this.style.background = 'rgba(231,181,63,.06)'"
          title="Upload Image"
        >
          <fa-icon
            [icon]="Plus"
            style="
              font-size: 13px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          ></fa-icon>
        </button>

        <input
          (paste)="onPaste($event)"
          type="file"
          #fileInput
          accept="image/*"
          style="display: none"
          (change)="onFileSelected($event)"
        />

        <textarea
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          (paste)="onPaste($event)"
          [(ngModel)]="newMessage"
          (keydown)="onTextareaKeydown($event)"
          (input)="adjustHeight($event)"
          placeholder="Describe your issue…"
          rows="1"
          class="flex-1 custom-textarea"
          style="
            background: transparent !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            color: #e2e8f0;
            font-size: 0.78rem;
            padding: 0.35rem 0.6rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
            min-width: 0;
            resize: none;
            display: inline-block;
            line-height: 1.3;
            min-height: 20px;
            max-height: 120px;
            overflow-y: auto;
            scrollbar-width: none;
            margin: 0;
            word-break: break-word !important;
            overflow-wrap: break-word !important;
          "
        ></textarea>

        <button
          (click)="sendMessage($event)"
          class="send-button flex items-center justify-center flex-shrink-0"
          style="
            width: 30px;
            height: 30px;
            background: #e7b53f;
            border: none;
            border-radius: 7px;
            color: #0a0f1d;
            cursor: pointer;
            transition: background 0.15s;
          "
          onmouseover="this.style.background = '#f5cf6b'"
          onmouseout="this.style.background = '#e7b53f'"
        >
          <fa-icon
            [icon]="PaperPlane"
            style="
              font-size: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          ></fa-icon>
        </button>
      </div>
    </div>

    <div
      *ngIf="isCameraOpen"
      class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
    >
      <div
        style="
          background: #080c10;
          border: 1px solid rgba(231, 181, 63, 0.3);
          border-radius: 16px;
        "
        class="p-4 w-full max-w-md overflow-hidden shadow-2xl"
      >
        <div
          class="relative rounded-lg overflow-hidden bg-black aspect-video flex items-center justify-center"
        >
          <video
            #videoElement
            autoplay
            playsinline
            [hidden]="showPreview"
            class="w-full h-full object-cover"
          ></video>
          <canvas #canvasElement style="display: none"></canvas>

          <img
            *ngIf="showPreview"
            [src]="capturedImage"
            class="w-full h-full object-cover"
            alt="Preview"
          />
        </div>

        <div class="flex justify-center gap-4 mt-4">
          <ng-container *ngIf="!showPreview">
            <button
              style="
                width: 42px;
                height: 42px;
                background: #e7b53f;
                border: none;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #0a0f1d;
                cursor: pointer;
              "
              (click)="capturePicture()"
              title="Capture"
            >
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
                />
              </svg>
            </button>
          </ng-container>

          <ng-container *ngIf="showPreview">
            <button
              style="
                width: 42px;
                height: 42px;
                background: rgba(231, 181, 63, 0.1);
                border: 1px solid #e7b53f;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #e7b53f;
                cursor: pointer;
              "
              (click)="retakePhoto()"
              title="Retake"
            >
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            </button>
          </ng-container>

          <button
            style="
              width: 42px;
              height: 42px;
              background: rgba(248, 113, 113, 0.1);
              border: 1px solid #f87171;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #f87171;
              cursor: pointer;
            "
            (click)="closeCamera()"
            title="Close Camera"
          >
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <div #imageModal class="modal" (click)="closeImageModal()">
      <span class="close" (click)="closeImageModal()">&times;</span>
      <img class="modal-content" [src]="selectedImageUrl" alt="Image Preview" />
      <a
        *ngIf="selectedImageUrl"
        [href]="selectedImageUrl"
        download="image.jpg"
        class="download-button"
      >
        <fa-icon [icon]="Download" class="text-2xl"></fa-icon>
      </a>
    </div>
    <!-- Input Area  End -->
  </div>
</div>
